// Module-level debug mode state that persists for the session
let debugParams: string[] = [];
let isInitialized = false;
let debugParts: string[] = [];
let isInsideMapsStaging = false;

/**
 * Initialize debug mode from URL query parameters.
 * Called once during app initialization.
 */
export function initializeDebugMode(): void {
  if (isInitialized) return;
  const params = new URLSearchParams(window.location.search);
  // Check if debug mode is enabled via query parameter
  debugParams = (params.get("debugMode") ?? "").split(",");
  // Check if InsideMaps staging is enabled via query parameter
  isInsideMapsStaging = params.get("insideMapsStaging") === "true";
  // Check if debugParts is enabled via query parameter
  debugParts = (params.get("debugParts") ?? "").split(",").filter((s) => s.length > 0);
  isInitialized = true;
}

/**
 * Get the current debug mode state.
 * Automatically initializes if not already.
 */
export function getDebugMode(): boolean {
  if (!isInitialized) initializeDebugMode();
  return debugParams.includes("true") || debugParams.includes("1");
}

/**
 * Whether slot debugging is enabled.
 */
export function isSlotDebugMode(): boolean {
  if (!isInitialized) initializeDebugMode();
  return debugParams.includes("slots");
}

export function getDebugParts(): string[] {
  if (!isInitialized) initializeDebugMode();
  return debugParts;
}

/**
 * Whether InsideMaps should use the staging environment.
 * Enabled via ?insideMapsStaging=true query parameter.
 */
export function isInsideMapsStagingMode(): boolean {
  if (!isInitialized) initializeDebugMode();
  return isInsideMapsStaging;
}
